import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

const windowWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1024)

function onResize() {
  windowWidth.value = window.innerWidth
}

export function useTableView() {
  // Cards automatico ate 1024px (celular + tablet), tabela acima
  const estiloTabela = computed(() => {
    return windowWidth.value <= 1024 ? 'card' : 'table'
  })

  const visualizacaoTabela = estiloTabela

  function setView(_view: string) {
    // noop — visualizacao e automatica por largura
  }

  onMounted(() => window.addEventListener('resize', onResize))
  onBeforeUnmount(() => window.removeEventListener('resize', onResize))

  return { estiloTabela, visualizacaoTabela, setView }
}
